// extracted by mini-css-extract-plugin
module.exports = {"button":"delete_watcher_button-module__button--6SzNY"};